import { useAuth0 } from '@auth0/auth0-react';
import { toast } from 'sonner';
import { useUserSignupNavigationContext } from '@/Context/UserSignupNavigationContext';
import UIStrings from '@/Utils/UIStrings';

interface UseVerifiedOnMobileInstructionsInterface {
    proceedToProductHandler: () => Promise<void>;
}

function useVerifiedOnMobileInstructions(): UseVerifiedOnMobileInstructionsInterface {
    const { getIdTokenClaims } = useAuth0();
    const { navigateToNextPage, refreshTokenAsync } = useUserSignupNavigationContext();

    const proceedToProductHandler = async () => {
        await refreshTokenAsync();
        const claims = await getIdTokenClaims();
        if (!claims?.email_verified) {
            toast.error(UIStrings.ItSeemsLikeEmailWasNotVerified);
            return;
        }
        navigateToNextPage();
    };

    return { proceedToProductHandler };
}

export default useVerifiedOnMobileInstructions;
